import React, { Fragment } from "react";
import { format } from "date-fns";

function OrderDetails({ order, shippingAddress }) {
  return (
    <div>
      <div
        className="fs-18"
        style={{
          display: "flex",
          margin: "0px 0px 20px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            textDecoration: "underline",
            textUnderlineOffset: "10px",
            textDecorationThickness: "2px",
            whiteSpace: "nowrap",
          }}
        >
          Order Details{" "}
        </p>
        <p style={{ color: "#33333399", fontSize: "14px" }}>
          (ordered on {format(new Date(order && order !== null && order.order_created_at), "dd MMM yyyy")})
        </p>
      </div>
      {order && order !== null && (
        <Fragment>
          <p style={{ marginTop: "30px", color: "#33333399" }}>
            Order id:{" "}
            <span style={{ color: "#333", fontWeight: "500" }}>
              {order.order_id}
            </span>
          </p>
          <p style={{ marginTop: "20px", color: "#33333399" }}>
            Order number:{" "}
            <span style={{ color: "#333", fontWeight: "500" }}>
              {order.order_name || order.order_number}
            </span>
          </p>
          <p style={{ marginTop: "20px", color: "#33333399" }}>
            Order total price:{" "}
            <span style={{ color: "#333", fontWeight: "500" }}>
              ₹ {order.total_order_price}
            </span>
          </p>
          <div style={{ marginTop: "20px", color: "#33333399" }}>
            Order items:{" "}
            <div
              style={{ color: "#333", fontWeight: "500", marginTop: "20px" }}
            >
              {order.items.map((item) => {
                return (
                  <div
                    key={item.variant_id}
                    style={{
                      display: "flex",
                      marginTop: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ width: "60px" }}>
                      <img
                        src={item.src.src}
                        alt={item.src.alt !== null ? item.src.alt : "Preview"}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div style={{ marginLeft: "20px" }}>
                      <p>{item.title}</p>
                      <p style={{ marginTop: "6px", color: "#33333399" }}>
                        {item.variant_title}
                      </p>
                    </div>
                    <div
                      style={{
                        marginLeft: "auto",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <p>x{item.quantity}</p>
                      <p style={{ fontWeight: "600", marginLeft: "10px" }}>
                        ₹{item.price}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <p style={{ marginTop: "20px", color: "#33333399" }}>
            Phone Number:{" "}
            <span style={{ color: "#333", fontWeight: "500" }}>
              {order.user_phone_number}
            </span>
          </p>
        </Fragment>
      )}
      {shippingAddress && shippingAddress !== null && (
        <p style={{ marginTop: "20px", color: "#33333399" }}>
          Shipping Address:{" "}
          <span style={{ color: "#333", fontWeight: "500" }}>
            {shippingAddress.address_line1},{shippingAddress.address_line2}{" "}
            {shippingAddress.address_line2 !== null && ","}{" "}
            {shippingAddress.city} - {shippingAddress.pin},{" "}
            {shippingAddress.state}, {shippingAddress.country}
          </span>
        </p>
      )}
      <p style={{ marginTop: "20px", color: "#33333399" }}>
        <a
          href={order && order!==null && order.order_status_url}
          style={{ color: "#333" }}
          target="_blank"
          rel="noreferrer"
        >
          View Order status
        </a>
      </p>
    </div>
  );
}

export default OrderDetails;
